import { getItem } from './local-storage'

export const isAuthenticated = () => {
  // Try token refresh lifetime
  const refreshLifetime = getItem('refresh_valid_till')
  if (refreshLifetime) {
    return Date.now() < refreshLifetime
  }
  // user can no longer be authenticated
  return false
}

export const getAccessToken = () => {
  if (isAuthenticated()) {
    return getItem('access_token')
  }

  return false
}
